"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CornerDownIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.CornerDownIcon = (0, react_1.forwardRef)(function CornerDownIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.05011 9.67309C6.86264 9.86061 6.75732 10.1149 6.75732 10.3801C6.75732 10.6452 6.86264 10.8996 7.05011 11.0871L11.2931 15.3301C11.4806 15.5176 11.7349 15.6229 12.0001 15.6229C12.2653 15.6229 12.5196 15.5176 12.7071 15.3301L16.9501 11.0871C17.043 10.9942 17.1166 10.8839 17.1668 10.7625C17.217 10.6412 17.2429 10.5111 17.2428 10.3797C17.2428 10.2484 17.2169 10.1183 17.1665 9.997C17.1162 9.87567 17.0425 9.76543 16.9496 9.67259C16.8567 9.57974 16.7464 9.50611 16.625 9.45588C16.5037 9.40566 16.3736 9.37984 16.2423 9.37988C16.1109 9.37993 15.9809 9.40585 15.8595 9.45615C15.7382 9.50646 15.628 9.58018 15.5351 9.67309L12.0001 13.2081L8.46411 9.67309C8.27658 9.48561 8.02227 9.3803 7.75711 9.3803C7.49195 9.3803 7.23764 9.48561 7.05011 9.67309Z", fill: "currentColor" })));
});
